import { getApi, patchApi } from "./apiService";

export const getAllOrders = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`mp/order/?${queryString}`);
};

export const UpdateOrderStatus = async (orderId, data) => {
    return await patchApi(`/mp/order/${orderId}/status`, data)
}

export const getOrderSummary = async () => {
    return await getApi("/mp/order/order-summary")
}

export const ExportOrdersData = async () => {
    return await getApi("/mp/order/export-orders")
}
